import React, { useContext, useEffect, useState } from "react";
import { AnalisisCreditoContext } from "./AnalisisCreditoScreen";
import request from "../../Helpers/API";
import Swal from "sweetalert2";
import PlantillaScreen from "../helpers/PlantillaScreen";
import { LoaderScreen } from "../components/LoaderScreen";
import ComputerIcon from "@mui/icons-material/Computer";
import { CargarDocumentacionVendedor } from "../Credito/CreditoCondicionado/CargarDcoumentacionVendedor";
import FacturarEquipoCondicionado from "../Credito/CreditoCondicionado/FacturarEquipoCondicionado";
import { CargarPagareEquipCondicionado } from "../Credito/CreditoCondicionado/CargarPagareEquipCondicionado";
import { CargarDocumentacionAprobadaCondicionado } from "../Credito/CreditoCondicionado/CargarDocumentacionAprobadaCondicionado";
import { ValidarCondicionesOperacionCondicionada } from "../Credito/CreditoCondicionado/ValidarCondicionesOperacionCondicionada";
import { AnalizarDocumentacionAprobadaCondicionado } from "../Credito/CreditoCondicionado/AnalizarDocumentacionAprobadaCondicionado";
import { FinalizarSolicitudCreditoCondicionado } from "../Credito/CreditoCondicionado/FinalizarSolicitudCreditoCondicionado";
import MdlSolicitudCreditoCondicionadoScreen from "../Credito/CreditoCondicionado/MdlSolicitudCreditoCondicionadoScreen";
import TimeLineTargetCondicionado from "./TimeLine/TimeLineTargetCondicionado";

export const AnalisisCreditoCondicionadoTimeline = ({
    data,
    estado,
    upload,
    direccion
}) => {
    const { state } = useContext(AnalisisCreditoContext);
    const [openSolicitud, setOpenSolicitud] = useState(false);
    const [comentarios, setComentario] = useState([]);
    const [value, setValue] = useState(0);
    const [seleccionado, setSeleccionado] = useState(0);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    // useEffect(() => {
    //     onActualizarComentarios();
    // }, []);
    const onActualizarComentarios = () => {
        if (
            state.folio === undefined ||
            state.folio === null ||
            state.folio.length !== 13
        ) {
            return;
        }
        setLoader({ ...loader, mostrar: true });
        request
            .get(`AnalisisSolicitudCreditoComentarios/Listado?folio=${state.folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setComentario(result);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("PRESTAMO A CLIENTES", JSON.stringify(error), "error");
            });
    };
    return (
        <PlantillaScreen
            titulo={"PROCESO DE SOLICITUD DE CREDITO CONDICIONADO"}
            className={"analisis-sc-procesos"}
        >
            <LoaderScreen loader={loader} />
            <div className="analisis-sc-procesos-timeline-title ">
                {state.cliente}
            </div>
            <div className="analisis-sc-procesos-timeline-condicionado scroll-4">
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Genero Solicitud"}
                    subtitle={"Gerente de linea"}
                    footer={{
                        tiempoestimado: data[0].estado,
                        leyenda: data[0].creado,
                        duracion: data[0].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[0].control}
                    active={1 === Number(estado.pantallacompleta)}
                    value={0}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Operacion condicionada"}
                    subtitle={"Gerente de linea"}
                    footer={{
                        tiempoestimado: data[1].estado,
                        leyenda: data[1].creado,
                        duracion: data[1].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[1].control}
                    active={2 === Number(estado.pantallacompleta)}
                    value={1}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Validar condiciones"}
                    subtitle={"Gerente de finanzas"}
                    footer={{
                        tiempoestimado: data[2].estado,
                        leyenda: data[2].creado,
                        duracion: data[2].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[2].control}
                    active={3 === Number(estado.pantallacompleta)}
                    value={2}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Facturar equipo"}
                    subtitle={"Cajera"}
                    footer={{
                        tiempoestimado: data[3].estado,
                        leyenda: data[3].creado,
                        duracion: data[3].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[3].control}
                    active={4 === Number(estado.pantallacompleta)}
                    value={3}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Cargar pagare Equip"}
                    subtitle={"Cajera"}
                    footer={{
                        tiempoestimado: data[4].estado,
                        leyenda: data[4].creado,
                        duracion: data[4].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[4].control}
                    active={5 === Number(estado.pantallacompleta)}
                    value={4}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Cargar documentación"}
                    subtitle={"Gerente de linea"}
                    footer={{
                        tiempoestimado: data[5].estado,
                        leyenda: data[5].creado,
                        duracion: data[5].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[5].control}
                    active={6 === Number(estado.pantallacompleta)}
                    value={5}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Analizar documentación"}
                    subtitle={"Gerente de finanzas"}
                    footer={{
                        tiempoestimado: data[6].estado,
                        leyenda: data[6].creado,
                        duracion: data[6].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[6].control}
                    active={7 === Number(estado.pantallacompleta)}
                    value={6}
                    setValue={setValue}
                    seleccionado={seleccionado}
                    setSeleccionado={setSeleccionado}
                />
                <TimeLineTargetCondicionado
                    icon={<ComputerIcon />}
                    title={"Finalizar solicitud"}
                    subtitle={"Gerente de finanzas"}
                    footer={{
                        tiempoestimado: data[7].estado,
                        leyenda: data[7].creado,
                        duracion: data[7].tiempoestimado,
                        comentarios: "",
                    }}
                    openModal={setOpenSolicitud}
                    color={data[7].control}
                    active={8 === Number(estado.pantallacompleta)}
                    value={7}
                    setValue={setValue}
                    endtarget={true}
                    seleccionado={0}
                    setSeleccionado={setSeleccionado}
                />
            </div>
            {openSolicitud === true && value === 0 ? (
                <MdlSolicitudCreditoCondicionadoScreen
                    folio={state.folio}
                    setLoader={setLoader}
                    loader={loader}
                />
            ) : value === 1 ? (
                <CargarDocumentacionVendedor
                    folio={estado.folio}
                    setLoader={setLoader}
                    loader={loader}
                    idproceso={100}
                    upload={upload}
                />
            ) : value === 2 ? (
                <ValidarCondicionesOperacionCondicionada
                    folio={estado.folio}
                    setLoader={setLoader}
                    loader={loader}
                    upload={upload}
                />
            ) : // <ValidarDocumentacionCondicionada
                //     folio={estado.folio}
                //     setLoader={setLoader}
                //     loader={loader}
                //     idproceso={150}
                //     upload={upload}
                // />
                value === 3 ? (
                    <FacturarEquipoCondicionado
                        folio={estado.folio}
                        setLoader={setLoader}
                        loader={loader}
                        upload={upload}
                    />
                ) : value === 4 ? (
                    <CargarPagareEquipCondicionado
                        folio={state.folio}
                        setLoader={setLoader}
                        loader={loader}
                        upload={upload}
                    />
                ) : value === 5 ? (
                    <CargarDocumentacionAprobadaCondicionado
                        folio={state.folio}
                        setLoader={setLoader}
                        loader={loader}
                        idproceso={30}
                        upload={upload}
                    />
                ) : value === 6 ? (
                    <AnalizarDocumentacionAprobadaCondicionado
                        folio={state.folio}
                        setLoader={setLoader}
                        loader={loader}
                        idproceso={30}
                        upload={upload}
                    />
                ) : value === 7 ? (
                    <FinalizarSolicitudCreditoCondicionado
                        folio={state.folio}
                        setLoader={setLoader}
                        loader={loader}
                    />
                ) : (
                    <MdlSolicitudCreditoCondicionadoScreen
                        folio={state.folio}
                        setLoader={setLoader}
                        loader={loader}
                    />
                )}
        </PlantillaScreen>
    );

};
